module.exports = __webpack_public_path__ + "static/glenbosch-66b57cd9ca09318c8a66034e5311440b.jpg";